export default __webpack_public_path__ + "static/media/PaquetePersona.e99b1756.svg";